import actionTypes from './actionTypes';

const reducer = (state = [], action) => {
    // When we request data, we will set state back to [] so loading icon will be displayed
    if (action.type === actionTypes.REQUEST_LEADERS) {
        return [];
    }
    if (action.type === actionTypes.LEADERS_RESPONSE && action.payload.success) {
        return action.payload.response;
    }
    return state;
};

export default reducer;
